import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { Dispatch, SetStateAction } from "react"

interface Props {
  children: React.ReactNode
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const Modal = ({ children, open, setOpen }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={(val) => {
        // Don't close if clicked on a notification
        // @ts-ignore
        if (event?.path?.some((elem) => elem.classList?.contains("notification"))) {
          return
        }
        setOpen(val)
      }}
      className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen justify-center text-center sm:block sm:items-end sm:p-0 sm:px-4">
        <DialogBackdrop
          transition
          className="fixed inset-0 z-0 bg-gray-500/80 transition-opacity duration-300 ease-out data-[closed]:opacity-0"
        />

        {/* This element is to trick the browser into centering the modal contents. */}
        <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">
          &#8203;
        </span>

        <DialogPanel
          transition
          className="relative z-10 inline-block w-screen transform bg-white px-4 pt-5 pb-4 text-left align-bottom shadow-xl transition-all duration-300 ease-out data-[closed]:translate-y-4 data-[closed]:opacity-0 sm:my-8 sm:w-fit sm:rounded-lg sm:p-6 sm:align-middle data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">
          <div>{children}</div>
          <div className={`absolute top-4 right-4 sm:block`}>
            <button
              type="button"
              className={`focus-visible:ring-primary-600 rounded-md text-gray-400 hover:text-gray-500 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none`}
              onClick={() => setOpen(false)}>
              <span className="sr-only">Close</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default Modal
